import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 18 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M14 16h-3v-6H7v6H4V6.704L9 2.33l5 4.374zm3.658-8.753-8-7a1 1 0 0 0-1.316 0l-8 7A1.001 1.001 0 0 0 1 9h1v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9h1a1.001 1.001 0 0 0 .658-1.753"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <path fill="currentColor" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
